import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
// import Icon from '@material-ui/core/Icon'

import { InputGroupData } from "../../interfaces/ui/InputGroupData";
import { useFormContext } from "react-hook-form";
import { Icon } from "@mui/material";

//Componente de Prime React para renderizar un input con un icono con manejador de errores
const InputGroup = ({
  itemData,
  col,
}: {
  itemData: InputGroupData;
  col?: string;
}) => {
  const { name, placeholder, icon, required, maxChars } = itemData;

  const { register, watch, formState } = useFormContext();
  const watcher = watch();
  const { errors, touchedFields, dirtyFields } = formState;

  const errorText = errors[name as keyof typeof errors]?.message;

  return (
    <div
      className={`input-group-responsive ${col || "w-3/6"} p-2 flex flex-col`}
    >
      <Box sx={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
        {icon && <Icon className={icon} style={{ color: 'action.active', width: "35px", alignSelf:"center" }}/>}
        <TextField
          id="input-with-sx"
          {...register(name)}
          label={placeholder}
          variant="standard"
          sx={{ width: "95%", maxWidth: `${col || "330px"}` }}
        />
      </Box>

      {/* Administración de Errores */}
      {required &&
        touchedFields[name] &&
        !dirtyFields[name] &&
        !errors[name] && (
          <p className="error-message">Este campo es requerido</p>
        )}
      {errors && <p className="error-message">{errorText?.toString()}</p>}
      {maxChars &&
        maxChars > 0 &&
        touchedFields[name] &&
        watcher[name].length > maxChars &&
        !errors[name] && (
          <p className="error-message">
            Has excedido el máximo de {maxChars} caracteres
          </p>
        )}
      {maxChars &&
        maxChars > 0 &&
        touchedFields[name] &&
        watcher[name].length < maxChars &&
        !errors[name] && (
          <p className="error-message">El mínimo es {maxChars} caracteres</p>
        )}
    </div>
  );
};

export { InputGroup };
